import React, { Component,useState } from "react";
import { v4 as uuid } from "uuid";
import { ChevronDownIcon, PlusIcon, TrashIcon } from '@heroicons/react/16/solid'
import  {FieldsModel} from "@/models/PPC/Fields";
class FieldGroup extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {insertItem: new FieldsModel(), selectedGroup: null, updateKey: uuid()}
        

    }

    insertEventHandler = (event, selectedGroup, currentTag) => {
        event.stopPropagation();
        const {data} = this.props;
        const fieldItem = data.addField({field_type_key: currentTag.key, field_type_group: selectedGroup.key, fieldkey: currentTag.fieldkey});
        
        this.setState({insertItem: fieldItem, selectedGroup:selectedGroup})
      //  setInsert( true );
        
        return false;
    }
    
    removeFieldEventHandler=(event, uid) => {
        event.stopPropagation();
        const {data} = this.props;
        if(data) {
            data.deleteField(uid);
            this.setState( {updtaeKey: uuid()} );
        }
        return false;        
    }
    
    render() {
        const {data, settings, group, title,placeholder} = this.props;
        let {field_groups, fields} = data;
        const {insertItem, selectedGroup} = this.state;
        let view = null;
        
        if( (field_groups && typeof field_groups == 'object' && field_groups.length > 0) == false) {
            field_groups = settings.fieldtypes;
        }
        
        
        if(group) {
            if(field_groups && typeof field_groups == 'object' && field_groups.length > 0) {
                
                const selectedGroupItem = field_groups.where('fieldtype', group).get(false, true);
                
                if(selectedGroupItem) {
                    view = CreateGroupPanel( {data:fields,groupItem:selectedGroupItem, insertItem:insertItem, insertEvent:this.insertEventHandler, selectedGroup:selectedGroup, settings:settings, removeFieldEvent:this.removeFieldEventHandler, title: title, placeholder:placeholder} );
                }
            } else {
                                
            } 
        } else {
        
        view =  (
            <>
            {field_groups && typeof field_groups == 'object' && field_groups.length > 0 && 
                field_groups.map( (groupItem) => {
                    
                    return CreateGroupPanel( {data:fields,groupItem:groupItem, insertItem:insertItem, insertEvent:this.insertEventHandler, selectedGroup:selectedGroup, settings:settings,removeFieldEvent:this.removeFieldEventHandler, title: title, placeholder:placeholder} );
                
            })}
            </>
            
        )
        }
        
        return view;
    }
}



export default FieldGroup;

function CreateGroupPanel({...props}) {
const {groupItem, settings, data, insertItem, removeFieldEvent, title, placeholder} = props;
const {fieldtypes} = settings;
const tags = fieldtypes.where('groupkey', groupItem.fieldkey).get();

const insertEventHandler = (event) => {
    event.stopPropagation();
    
    if(props?.insertEvent) {
        props?.insertEvent(event, groupItem, tags[0]);
    }
  //  setInsert( true );
    
    return false;
}

return (
    
    <div className="w-full">
        <CreateInput title={title} placeholder={placeholder} groupItem={groupItem} tags={tags} insertEventHandler={insertEventHandler} insertItem={insertItem} data={data} removeFieldEvent={removeFieldEvent}/>
    </div>
)
}

const CreateInput = ({...props}) => {
const {tags, insertItem, groupItem, data, removeFieldEvent, title, placeholder} = props;
let fieldItem = null;
if( data && typeof data?.length == 'number'  && data.length == 0 ) {
        fieldItem = data.add( new FieldsModel({field_type_key: tags[0].key, field_type_group: groupItem.key, fieldkey: tags[0].fieldkey}) );
}

let items = ( (data && typeof data?.length == 'number'  && data.length > 0) ? data.where('is_deleted', false).where('field_type_group', groupItem.key).get()  : [] ) ;

if(items.length == 0) {
    fieldItem = new FieldsModel({field_type_key: tags[0].key, field_type_group: groupItem.key, fieldkey: tags[0].fieldkey});
    data.add( fieldItem );
    //fieldItem = data.add(  );
    items.push(fieldItem);
}



const onChangeTag = (event, item) => {
    const {tags, insertItem} = props;
    
    let selectedTag;
    for(const tag of tags) {
        if(tag.uid == event.target.value) {
            selectedTag = tag;
            break;    
        }
    }
    
    item.setValue('fieldkey', selectedTag.fieldkey);
    //const selectedTag = tags.findOne(event.target.value, 'uid');
    
    
    return false;
}

const onBlur = (event, item) => {
    const {tags, insertItem} = props;
    item.setValue('fieldval', event.target.value);
    item.setValue('data.value', event.target.value);
    //const selectedTag = tags.findOne(event.target.value, 'uid');
    return false;
}

const onRemoveItem = (event, item) => {
    item.setValue( 'is_deleted', true );
    if(removeFieldEvent) {
        removeFieldEvent(event, item.uid);
    }
    return false;   
}


    return (
        <>
        <div className="mt-4 group">
        <div className={"flex  w-full pr-1 "}>
           <label htmlFor="phone-number" className="w-full text-sm/6 font-medium text-gray-900 dark:text-white">
             {title}
           </label>
           <button
             type="button"
             className="hidden group-hover:block  rounded-md bg-gray-300 p-1 text-white shadow-xs hover:bg-indigo-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
           >
             <PlusIcon aria-hidden="true" className="size-4" 
             onClick={props?.insertEventHandler}/>
           </button>
           </div>
           <div className="mt-2">
             <div className="flex border rounded-md bg-white outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600 dark:bg-white/5 dark:outline-white/10 dark:has-[input:focus-within]:outline-indigo-500">
                 <div className={"grid grid-cols-1 w-full pr-1"}> 
{items && items.map( (insertItem, index) => {                 
                    return (<div className="w-full flex rowitem">
                   {tags && tags.length > 0 &&
                   <div className="grid shrink-0 grid-cols-1 focus-within:relative">
                     <select
                       id={insertItem.uid}
                       name="newItem"
                       onChange={(event) => {onChangeTag(event, insertItem)}}
                       //onSelect={(event) => {onChangeTag(event)}}
                       className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-7 pl-3 text-base text-gray-500 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-transparent dark:text-gray-400 dark:*:bg-gray-800 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"
                     >
                     {tags && tags.length > 0 && tags.map((item => {
                        //  
                       return (<option value={item.uid} selected={insertItem && insertItem?.fieldkey == item.fieldkey ? true : false}>{item.fieldval}</option>) 
                     }))}
                     </select>
                     <ChevronDownIcon
                       aria-hidden="true"
                       className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400"
                     />
                   </div>
                   }
                   <input
                     id={"inp"+insertItem.uid}
                     name={"inp"+insertItem.uid}
                     type="text"
                     placeholder={placeholder}
                     defaultValue={ (insertItem && insertItem?.data && insertItem?.data?.value) ? insertItem?.data?.value : '' }
                     onBlur={(event) => {onBlur(event, insertItem)}}
                     className="block min-w-0 grow bg-white p-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6 dark:bg-transparent dark:text-white dark:placeholder:text-gray-500"
                   />
                   {index > 0 && 
                    <button key={'removeButton_'+insertItem.uid}
                      type="button"
                      onClick={(event) => {onRemoveItem(event, insertItem)}}
                      className="hidden group-hover:block rounded-md mt-1 max-h-6 leading-[12px] bg-gray-300 p-1 text-white shadow-xs hover:bg-gray-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 dark:bg-gray-500 dark:shadow-none dark:hover:bg-gray-400 dark:focus-visible:outline-gray-500"
                    >
                      <TrashIcon aria-hidden="true" className="size-3" />
                    </button>                    
                    }
                   </div>)
                   })
}             
                   
                   </div>
             </div>
           </div>
         </div>
</>
);
}